
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppAdministratorPlayersCategoriesListIndex} from "@/models/app/administrator/players/categories/list/index";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppAdministratorPlayersCategoriesListFormCreateIndexVue from "@/views/app/administrator/players/categories/list/form/create.vue";
import AppAdministratorPlayersCategoriesListFormUpdateIndexVue from "@/views/app/administrator/players/categories/list/form/update.vue";
import AppAdministratorPlayersCategoriesListFormRemoveIndexVue from "@/views/app/administrator/players/categories/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AppAdministratorPlayersCategoriesListFormCreateIndexVue,
    AppAdministratorPlayersCategoriesListFormUpdateIndexVue,
    AppAdministratorPlayersCategoriesListFormRemoveIndexVue,
  },
})
export default class AppAdministratorPlayersCategoriesListIndexVue extends Vue {
  isLoading: boolean | null = false;

  playerCategories: Array<AppAdministratorPlayersCategoriesListIndex> = [];

  async getPlayerCategories(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/administration/player-categories`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.playerCategories = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getPlayerCategories();
  }
}
